import { render, staticRenderFns } from "./SaveTheRouteList.vue?vue&type=template&id=35041c09&scoped=true&"
import script from "./SaveTheRouteList.vue?vue&type=script&lang=js&"
export * from "./SaveTheRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35041c09",
  null
  
)

export default component.exports